import { Office } from './office.model';
import { Broker } from './broker.model';
import { Owner } from './owner.model';
import { Address } from './address.model';
import { ProductType } from './product.model';
import { ID } from './ID.model';
import { CategoryV2 } from '../components/generics/data-printer-v2/data-printer-v2.component';

export type PropertyType = 'COMERCIAL' | 'VIVIENDA' | 'AMBOS';

export interface Property {
    codigo: string;
    activo?: boolean;
    alquiler: number;
    direccion: Address;
    expensas: number;
    fechaActualizacion?: string;
    fechaCreacion?: string;
    id?: ID;
    agente?: Broker;
    oficina?: Office;
    propietarios?: Owner[];
    codigosPropietarios?: string[];
    tipo: PropertyType;
    actualizacion?: number;
    periodoActualizacion?: number;
    ultimoProducto?: ID;
    tipoProducto: ProductType;
    cantidadAmbientes?: number;
}

export function generatePropertyCategories(property?: Property) {
    if (!property) return [];

    const categories: CategoryV2[] = [];

    if (property.direccion) {
        categories.push({
            labelWidth: '105px',
            maxWidth: '450px',
            items: [
                { label: 'Tipo de vía', value: property.direccion.tipoCalle },
                { label: 'Calle', value: property.direccion.calle },
                { label: 'Número', value: property.direccion.numero },
                { label: 'Piso', value: property.direccion.piso },
                { label: 'Departamento', value: property.direccion.departamento },
                { label: 'Código postal', value: property.direccion?.codigoPostal },
            ]
        }, {
            labelWidth: '160px',
            maxWidth: '450px',
            items: [
                { label: 'Provincia', value: property.direccion?.localidad?.provincia?.descripcion },
                { label: 'Municipio', value: property.direccion?.localidad?.municipio?.descripcion },
                { label: 'Localidad', value: property.direccion?.localidad?.descripcion },
                { label: 'Tipo de propiedad', value: property.tipo, type: 'text' },
                { label: 'Cantidad de ambientes', value: property.cantidadAmbientes },
            ]
        });
    }

    return categories;
}
